import React, { useState } from 'react';
import { ThumbsUp, ThumbsDown } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const VOTES_KEY = 'resiax_faq_votes';
const VOTER_KEY = 'resiax_faq_voter';

const getVoterId = () => {
  let id = localStorage.getItem(VOTER_KEY);
  if (!id) {
    id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9_-]/g, '');
    localStorage.setItem(VOTER_KEY, id);
  }
  return id;
};
const readVotes = () => { try { return JSON.parse(localStorage.getItem(VOTES_KEY) || '{}'); } catch { return {}; } };

export const FaqHelpfulVote = ({ item, content, onAskInstead }) => {
  const [vote, setVote] = useState(() => readVotes()[item.id] ?? null);
  const [busy, setBusy] = useState(false);

  const cast = async (helpful) => {
    if (busy || vote === helpful) return;
    setBusy(true);
    try {
      const res = await fetch(`${API}/api/faq/${item.id}/vote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ helpful, voter_id: getVoterId() }),
      });
      if (!res.ok) throw new Error('vote failed');
      setVote(helpful);
      localStorage.setItem(VOTES_KEY, JSON.stringify({ ...readVotes(), [item.id]: helpful }));
    } catch {
      // silent — feedback widget must never interrupt reading
    } finally {
      setBusy(false);
    }
  };

  const btn = (active) => `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors disabled:opacity-60 ${
    active ? 'bg-[#1F1E1E] text-white border-[#1F1E1E]' : 'bg-white text-[#3B3535] border-gray-200 hover:border-[#B5541B] hover:text-[#B5541B]'
  }`;

  return (
    <div className="flex flex-wrap items-center gap-3 mt-4" data-testid={`faq-helpful-${item.slug}`}>
      <span className="text-xs font-medium text-[#3B3535]/70">{content.prompt}</span>
      <div className="flex items-center gap-2">
        <button type="button" data-testid={`faq-helpful-yes-${item.slug}`} aria-pressed={vote === true} disabled={busy} onClick={() => cast(true)} className={btn(vote === true)}>
          <ThumbsUp className="w-3.5 h-3.5" /> {content.yesLabel}
        </button>
        <button type="button" data-testid={`faq-helpful-no-${item.slug}`} aria-pressed={vote === false} disabled={busy} onClick={() => cast(false)} className={btn(vote === false)}>
          <ThumbsDown className="w-3.5 h-3.5" /> {content.noLabel}
        </button>
      </div>
      {vote !== null && (
        <span className="text-xs text-[#3B3535]/70" data-testid={`faq-helpful-thanks-${item.slug}`}>
          {content.thanks}
          {vote === false && onAskInstead && (
            <>
              {' '}
              <button type="button" data-testid={`faq-helpful-ask-${item.slug}`} onClick={() => onAskInstead(item)} className="font-semibold text-[#B5541B] hover:underline">
                {content.askInsteadLabel}
              </button>
            </>
          )}
        </span>
      )}
    </div>
  );
};
